import { Link } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { useSEO } from "@/lib/useSEO";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  useSEO({
    title: "Page not found · Better Through Boxing",
    description: "This page isn't available.",
    path: "/not-found",
    noindex: true,
  });
  return (
    <div className="App min-h-screen bg-[#050505] text-white">
      <SiteHeader />
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-24 md:py-32 text-center" data-testid="not-found-page">
        <div className="text-[#FF331F] text-xs uppercase tracking-[0.3em] font-bold mb-3">404</div>
        <h1 className="font-display font-bold uppercase text-5xl md:text-6xl tracking-tight leading-none mb-6">
          Page not found.
        </h1>
        <p className="text-zinc-400 text-base md:text-lg leading-relaxed mb-8">
          The page you&apos;re looking for either doesn&apos;t exist or has been hidden by the coach.
        </p>
        <Link
          to="/"
          className="inline-flex items-center bg-[#FF331F] hover:bg-[#FF5242] text-white font-bold uppercase tracking-widest text-xs px-5 py-3 rounded-sm"
          data-testid="not-found-home-link"
        >
          Back to home <ArrowRight className="ml-2 h-3 w-3" />
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}
